export default __webpack_public_path__ + "static/media/light-chop.ffbb1344.svg";